import axiosInstance from '../../../config/axiosInstance';
import { SupplierValidation } from "../View/Validation/SupplierValidation";

const handleChange = (event, formData, setFormData) => {
    const { name, value } = event.target;
    setFormData({
        ...formData,
        [name]: value,
    });
};

const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectRoleList) => {
    event.preventDefault();    
    const formErrors = SupplierValidation(formData);   
    setErrors(formErrors);
    if (Object.keys(formErrors).length === 0) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            formData.formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.formData.UserID = UserID;
            const response = await axiosInstance.post(`/Supplier/CreateSupplier`, formData);
            localStorage.setItem('SupplierID', response.data.SupplierID);
            return response.data.message;
        } catch (error) {
            debugger;
            console.error('Error posting data:', error);
        }
    }
};

export { handleChange, handleSubmit };
